import { put, takeLatest, all, select } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { agentLoaded } from './actions';
import { GET_AGENT } from './constants';
import { makeSelectAgentCode } from './selectors';
import { makeSelectModalOption } from '../Select/selectors';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';

function* fetchAgent() {
  const code = yield select(makeSelectAgentCode());
  const interval = yield select(makeSelectModalOption());
  const requestURL = `${API_URL}agent/${code}/statistics?interval=${interval}`;

  try {
    const parameters = {
      method: 'GET',
      headers: getRequestHeadersAsLogged(),
    };

    const request = yield fetch(requestURL, parameters).then(response =>
      responseHandler(response)
    );
    yield put(agentLoaded(request.data));
  } catch (err) {
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(GET_AGENT, fetchAgent);
}

export default function* agentsData() {
  yield all([actionWatcher()]);
}
